<template>
  <div class="tender-block">
    <h2 class="h2">{{ $t('2 ways to send your offer') }}</h2>
    <div class="options-grid">
      <UploadExcelOfPublicTender />
      <div class="options-grid__or">{{ $t('or') }}</div>
      <FixtenderSignUpOfPublicTender />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import FixtenderSignUpOfPublicTender from '@/containers/public-tender/main-column/send-offer/FixtenderSignUpOfPublicTender';
  import UploadExcelOfPublicTender from '@/containers/public-tender/main-column/send-offer/UploadExcelOfPublicTender';

  export default {
    name: 'SendOfferOfPublicTender',
    components: {
      UploadExcelOfPublicTender,
      FixtenderSignUpOfPublicTender,
    },
    computed: {
      ...mapState('publicTender', ['loadings']),
    },
    methods: {
      ...mapActions('publicTender', ['downloadXlsxHandler', 'openExcelModal', 'openPdfModal']),
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
